import { isFunction } from 'core/utils';

const renderIf = predicate => elemOrThunk =>
	predicate ? (isFunction(elemOrThunk) ? elemOrThunk() : elemOrThunk) : null;
export default renderIf;



// WEBPACK FOOTER //
// ./src/core/utils/templates/renderIf.js